// original product
export enum ProductField {
  Color = 'Color',
  Material = 'Material',
  Family = 'Family',
  Line = 'Line',
  Activity = 'Activity',
  Channels = 'Channels',
  Title = 'Title',
  SKU = 'SKU',
  StyleColorCode = 'StyleColorCode',
  ModelDescription = 'ModelDescription',
  WholesaleFreeTag = 'Wholesale Free Tag',
  RetailFreeTag = 'Retail Free Tag',
  Capsule = 'Capsule',
  Drop = 'Drop',
  RetailSalesPeriod = 'Retail Sales Period'
}
